import { FC } from "react";
import { useWidgetStore } from "../../stores";
import ItemRenderer from "./item-renderer";

const Dashboard: FC = () => {
  const items = useWidgetStore((s) => s.items);

  return (
    <div style={{ marginTop: 10 }}>
      {items.map((item) => (
        <ItemRenderer key={item.id} item={item} />
      ))}
    </div>
  );
};

export default Dashboard;
